export const STATUS_COLOR = {
  annual: '#7CD4FD',
  other: '#FF9966',
  planned: '#F6D0FE',
  holiday: '#F9DBAF',
  weekend: '#D0D5DD',
  na: '#f0f0f0',
  sick: '#FFB8C6',
};

export const STATUS_BORDER_COLOR = {
  annual: '#0DA6EA',
  other: 'black',
  planned: '#BA24D5',
  holiday: '#E04F16',
  weekend: '#667085',
  sick: '#FFB8C6',
};
